import Mousetrap from 'mousetrap';
import logger from '@/plugins/logger';
import store from '@/store';

let items = [];

export default class NavigationService {
  static async closeTopMost() {
    logger.log('navigation', 'close top most called', 'stack', items);
    if (items.length > 0) {
      let last = items[items.length - 1];
      logger.log('navigation', 'closing last:', last.name);
      let res = await last.close();
      if (res) {
        logger.log('navigation', 'close succeeded', last.name);
        let diff = store.state.navigationPosition - last.position;
        let newHistory = -diff - 1;
        logger.log('new history', newHistory, `current: ${store.state.navigationPosition}, last: ${last.position}`);
        store.commit('setNavigationPosition', last.position - 1);
        mutateHistory(newHistory);
        this.removeItem(last);
      }
    }
  }
  static isTopMost(item) {
    let last = items[items.length - 1];
    let IsTopMost = item.name === last.name;
    logger.log('navigation', 'is top most', IsTopMost);
    return IsTopMost;
  }
  static removeItem(item) {
    logger.log('navigation', 'remove item', item.name, 'found', items.find(x => x.name === item.name));
    items = items.filter(x => x !== item);
  }
  static addItem(item) {
    logger.log('navigation', 'add item', item.name);
    items.push(item);
    logger.log('navigation', 'add new to stack', item.name, 'stack:', items);
  }
  static isBackNavigated() {
    let back = store.getters['backNavigated'];
    logger.log('navigation', 'back', back);
    return back;
  }
}
Mousetrap.bind('esc', (e) => {
  e.preventDefault();
  logger.log('esc called');
  NavigationService.closeTopMost();
});

function mutateHistory(history) {
  try {
    window.history.go(history);
  } catch (error) {
    console.error(error);
  }
  return true;
}

window.NavigationStack = () => items;
window.MouseStack = Mousetrap;
